import * as React from 'react';
import {Draggable} from 'react-beautiful-dnd';
import BoxContainer from 'containers/BoxContainer';
import {ContextProvider} from './BlockContext';
import {Header} from './components/Header';
import {Content} from './components/Content';
import {Comments} from './components/Comments';
import {Score} from './components/Score';
import {BlockProps} from './types';

/**
 * The block component.
 * @param {BlockProps} props
 * @return {React.ReactElement<BlockProps>}
 * @constructor
 */
export default function Block(
    props: BlockProps,
): React.ReactElement<BlockProps> {
  return (
    <ContextProvider value={props}>
      <Draggable draggableId={props.id} index={props.index}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.draggableProps}>
            <BoxContainer>
              <Header provided={provided} snapshot={snapshot} />
              <Content />
              <Comments />
              <Score />
            </BoxContainer>
          </div>
        )}
      </Draggable>
    </ContextProvider>
  );
}
